export enum EnergieEnum {
  ELECTRICITE = 'ELECTRICITE',
  GAZ = 'GAZ',
  EAU = 'EAU',
  RESEAU_CHALEUR = 'RESEAU_CHALEUR',
  BOIS = 'BOIS',
  FIOUL = 'FIOUL',
  HYBRIDE = 'HYBRIDE',
  HYBRIDE2 = 'HYBRIDE2',
  CHAUFFAGE = 'CHAUFFAGE',
  ECS = 'ECS',
  REFROIDISSEMENT = 'REFROIDISSEMENT',
}
